import classNames from 'classnames';
import {getGridColumnStyles, Grid} from 'components/Grid';
import {MediaHarvester} from 'components/MediaHarvester';
import {Typography} from 'components/Typography';
import {ICategoryNode} from 'modules/categories/models/CategoryTree';
import {CategoryService} from 'modules/categories/services/CategoryService';
import Link from 'next/link';
import React, {memo, useCallback} from 'react';
import {CATALOG_ROUTE} from 'routing/constants';

import style from './style.module.scss';

const columnStyle = getGridColumnStyles({md: 3});

interface IProps extends ICategoryNode {}

export const SeoCategoryItem = memo<IProps>(function SeoCategoryItem({id, code, childrenCategory, title, icon}) {
    const makeCategoryLink = useCallback(
        (categoryNode: ICategoryNode) =>
            `${CATALOG_ROUTE}/${CategoryService.makeCategoryUrl(categoryNode.code, categoryNode.id)}`,
        []
    );

    return (
        <>
            <Link href={`${CATALOG_ROUTE}/${CategoryService.makeCategoryUrl(code, id)}`} scroll>
                <a className={style.titleContainer} data-skeleton-item>
                    <MediaHarvester className={style.icon} media={icon} />
                    <Typography className={style.title} element="h2" variant="h4">
                        {title}
                    </Typography>
                </a>
            </Link>

            {Boolean(childrenCategory.length) && (
                <Grid as="ul">
                    {childrenCategory.map((child) => (
                        <li className={classNames(style.child, columnStyle)} data-skeleton-item key={child.id}>
                            <Link href={makeCategoryLink(child)} scroll>
                                <a>
                                    <Typography className={style.childTitle} element="div" variant="elements-strong">
                                        {child.title}
                                    </Typography>
                                </a>
                            </Link>
                            {Boolean(child.childrenCategory.length) && (
                                <ul>
                                    {child.childrenCategory.map((subChild) => (
                                        <li className={style.subChild} key={subChild.id}>
                                            <Link href={makeCategoryLink(subChild)} scroll>
                                                <a>
                                                    <Typography
                                                        className={style.subChildTitle}
                                                        element="div"
                                                        variant="p"
                                                    >
                                                        {subChild.title}
                                                    </Typography>
                                                </a>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </Grid>
            )}
        </>
    );
});
